import React, { useEffect,useState } from "react";
import { useSelector } from "react-redux";
import ChoiceHighlighter from "../ChoiceHighlighter";

const AnswerBlockLabel = ({ data, text, key, onChoiceClick }) => {
  const { choiceSource } = useSelector((state) => state.data);

  const [selected, setSelected] = useState(true);

  useEffect(() => {
    //console.log(choiceSource, 'statess');
  }, [choiceSource]);

  const handleOnSelect = () => {
    //setSelected(!selected);
    //onChoiceClick(data);
  };

  // Handle keyboard activation (Enter/Space) for accessibility
  const handleKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleOnSelect();
    }
  };

  return (
    <div
      key={key}
      onClick={handleOnSelect}
      onKeyDown={handleKeyDown}
      role="checkbox"
      aria-checked={selected}
      tabIndex={0}
      className={`flex items-center gap-1 mb-2 max-h-28 overflow-y-auto`}
    >
      {selected ? (
        <div
          className="w-2 h-2 bg-info rounded-lg flex items-center justify-center shrink-0"
          aria-hidden="true"
        ></div>
      ) : (
        <div
          className="w-5 h-5 border-2 rounded flex items-center justify-center shrink-0"
          aria-hidden="true"
        ></div>
      )}
      <ChoiceHighlighter text={text} choices={choiceSource} />
    </div>
  );
};

export default AnswerBlockLabel;
